import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ClipboardCopy } from '../../clipboard-copy.service';
import { IconButtonComponent } from '../../common/button/components/icon-button/icon-button.component';
import { GroupComponent } from '../../common/group/group.component';
import { InputComponent } from '../../forms/input/input.component';

@Component({
  selector: 'rt-copy-input',
  styleUrls: ['./copy-input.component.less'],
  templateUrl: 'copy-input.component.html',
  standalone: true,
  imports: [GroupComponent, InputComponent, IconButtonComponent],
})
export class CopyInputComponent {
  @Input() public value: string;
  @Input() public hasOpenInNewTabButton: boolean = false;
  @Input() public hasCopyButton: boolean = true;
  @Input() public hasEditButton: boolean = false;
  @Output() public copied: EventEmitter<void> = new EventEmitter<void>();
  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  constructor(private clipboardCopy: ClipboardCopy) {}

  public copy(element: InputComponent): void {
    this.clipboardCopy.fromHtmlElement(element.input.nativeElement);
    this.copied.emit();
  }

  public onEdit(): void {
    this.edit.emit();
  }
}
